import React from 'react';
import styled from 'styled-components';
import { generatePath } from 'react-router-dom';
import { Link } from 'components/atoms/Link/Link';
import { Routes, FilterNames } from 'constants/index';
import { getPath } from 'utils';
import { Content } from 'mxp-schemas';

interface Props {
  topicSlug?: string;
  subtopicSlug?: string;
  itemList: State.Subtopic[] | State.TopicOption[] | any;
  className?: string;
  isAggByTopicPage?: boolean;
  isAggByProductTypePage?: boolean;
  isSubtopicLink?: boolean;
  isProductTypeLink?: boolean;
  productTypeSlug?: string;
  pageType?: string;
}
export const StandaloneLinkList: React.FC<Props> = React.memo(
  ({
    topicSlug,
    subtopicSlug,
    itemList,
    className = '',
    isSubtopicLink,
    isAggByTopicPage = false,
    isAggByProductTypePage = false,
    isProductTypeLink,
    productTypeSlug,
    pageType,
  }) => {
    return (
      <StyledList className={className}>
        {itemList.map((item: any) => {
          let to: string = '';
          const isProductAggPage: boolean = Boolean(isAggByTopicPage || isAggByProductTypePage);
          const isValidSubtopicLink: boolean = Boolean(isSubtopicLink && topicSlug);
          const contentTypeFilter: string = item.aggregationSlug ? `?${FilterNames.CONTENT_TYPE}=${item.slug}` : '';
          const subtopicFilter = `?${FilterNames.TOPIC_LEVEL1}=${item.slug}`;
          if (isProductAggPage) {
            isValidSubtopicLink
              ? (to = `${generatePath(getPath(Routes.CATEGORY_AGGS_PAGE), {
                  topicSlug,
                  categorySlug: Content.CategorySlugs.CPE_LEARNING,
                })}${subtopicFilter}`)
              : isProductTypeLink
              ? (to = `${generatePath(getPath(Routes.PRODUCT_AGGS_BY_TYPE_PAGE), {
                  productTypeSlug: item.aggregationSlug || item.slug,
                })}${contentTypeFilter}`)
              : (to = generatePath(getPath(Routes.PRODUCT_AGGS_BY_TOPIC_PAGE), { topicSlug: item.slug }));
          } else if (topicSlug) {
            to =
              pageType && pageType === 'skill'
                ? generatePath(getPath(Routes.SKILL_AGGS_PAGE), {
                    skillSlug: topicSlug,
                    subskillSlug: item.slug,
                  })
                : generatePath(getPath(Routes.TOPIC_AGGS_PAGE), {
                    topicSlug,
                    subtopicSlug: item.slug,
                  });
          }
          return (
            <StyledListItem key={item.id}>
              <StyledLink
                className={
                  (isAggByTopicPage && item.slug === topicSlug) ||
                  (isAggByProductTypePage && item.slug === productTypeSlug) ||
                  (!(isAggByProductTypePage && isAggByTopicPage) && item.slug === subtopicSlug)
                    ? 'active'
                    : ''
                }
                to={to}
                testId={`sl-${item.slug}`}
              >
                {item.name}
              </StyledLink>
            </StyledListItem>
          );
        })}
      </StyledList>
    );
  }
);

const StyledList = styled.ul`
  padding-left: 0;
  list-style: none;
  margin: 0;
  margin-bottom: ${props => props.theme.pxToRem(24)};
`;

const StyledListItem = styled.li`
  padding: ${props => `${props.theme.pxToRem(12)} 0 ${props.theme.pxToRem(12)} ${props.theme.pxToRem(12)}`};
  margin-bottom: ${props => props.theme.pxToRem(-8)};

  &:hover {
    a {
      color: #7c176f;
    }

    background-color: ${props => props.theme.colors.secondaryLightPurple};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledLink = styled(Link)`
  font-size: ${props => props.theme.pxToRem(16)};
  margin-bottom: 0;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  color: ${props => props.theme.colors.neutralBlack};
  line-height: ${props => props.theme.pxToRem(16)};
`;
